export default [{
        routerName: 'blogDetail',
        routerParams: 'id',
        routerQuery: '',
        routerSlug: 'slug',
        listRouterName: 'blog',
        linkable_type: 'Modules\\Blog\\Entities\\Post',
    },
    {
        routerName: 'industry',
        routerParams: '',
        routerQuery: 'townIds',
        routerSlug: '',
        listRouterName: 'industry',
        linkable_type: "Modules\\Industry\\Entities\\Town",
    },
    {
        routerName: 'unit',
        routerParams: 'id',
        routerQuery: '',
        routerSlug: 'slug',
        listRouterName: 'industry',
        linkable_type: "Modules\\Industry\\Entities\\Unit",
    },
    {
        routerName: 'industry',
        routerParams: '',
        routerQuery: 'categoryIds',
        routerSlug: '',
        listRouterName: 'industry',
        linkable_type: 'Modules\\Industry\\Entities\\IndustryCategory',
    },
    {
        routerName: 'blog',
        routerParams: '',
        routerQuery: 'categoryIds',
        routerSlug: '',
        listRouterName: 'blog',
        linkable_type: 'Modules\\Blog\\Entities\\Category',
    },
    {
        routerName: 'page',
        routerParams: 'page',
        routerQuery: '',
        routerSlug: 'slug',
        listRouterName: 'page',
        linkable_type: 'Modules\\Page\\Entities\\Page',
    },
    {
        routerName: 'aboutUs',
        routerParams: '',
        routerQuery: '',
        routerSlug: '',
        listRouterName: 'aboutUs',
        linkable_type: 'Custom\\AboutUs',
    },
    {
        routerName: 'contactUs',
        routerParams: '',
        routerQuery: '',
        routerSlug: '',
        listRouterName: 'contactUs',
        linkable_type: 'Custom\\ContactUs',
    },
]
// \Modules\Blog\Entities\Post::class,
// \Modules\Industry\Entities\Town::class,
// \Modules\Industry\Entities\Unit::class,
// \Modules\Industry\Entities\IndustryCategory::class,
// \Modules\Blog\Entities\Category::class,
// \Modules\Menu\Entities\MenuItem::class,
// \Modules\Page\Entities\Page::class,